/** Import assets */

import { Fragment } from "react";

import { Helmet }   from "react-helmet-async";

import { useLocation } from "react-router-dom";

import Cookies from "js-cookie";

import {
    INDEXABLE_SEO_LANGS,
    hreflangLinks,
    localizedAbsoluteUrl,
    localizedValue,
    normalizeLanguage
} from "../../../SEO/localizedMeta";

import {
    getRobotsDirective,
    resolveLanguage
} from "../../../../Configs/LanguageConfig";

import { buildProvisionalProductPath } from "../../../../Misc/Permalinks";

import "../../../../Styles/Products.css";

/**
 * 
 * @param { title, children } param0 
 * 
 * @returns single product layout component
 * 
 */

const SingleProductLayout = ( { data, children } ) => {

    const location = useLocation ();

    const { language } = resolveLanguage ( {

        search        : location.search,

        hostname      : typeof window === "undefined" ? "" : window.location.hostname,

        cookieLanguage : Cookies.get ( "i18next" )

    } );

    const currentLanguage = normalizeLanguage ( language );

    const routePath = buildProvisionalProductPath ( data );

    const canonicalHref = localizedAbsoluteUrl(routePath, currentLanguage);

    const alternateLinks = hreflangLinks ( routePath, INDEXABLE_SEO_LANGS, false );

    const productTypeLabels = {

        tire: {

            lv: "Riepa",

            en: "Tyre",

            ru: "Шина"

        },

        rim: {

            lv: "Disks",

            en: "Rim",

            ru: "Диск"

        },

        battery: {

            lv: "Akumulators",

            en: "Battery",

            ru: "Аккумулятор"

        }

    }[ data.productType ] || {

        lv: "Produkts",

        en: "Product",

        ru: "Товар"

    };

    const productCore = `${ data.manufacturer.name.toUpperCase () } ${ data.model }`;

    const productSpecs = data.productType === "tire"

        ? [

            data?.width,

            data?.height,

            data?.diameter ? `R${ parseInt ( data.diameter ) }${ data?.isCTire ? "C" : "" }` : null,

            data?.loadIndex,

            data?.speedRating?.toUpperCase ()

        ].filter ( Boolean ).join ( " " )

        : data.productType === "rim"

            ? [

                data?.width ? `${ data.width }J` : null,

                data?.diameter ? `R${ parseInt ( data.diameter ) }` : null,

                data?.pitchCircleDiameter,

                data?.offset ? `ET${ data.offset }` : null,

                data?.centreBore ? `CB${ data.centreBore }` : null

            ].filter ( Boolean ).join ( " " )

            : [

                data?.voltage ? `${ data.voltage }V` : null,

                data?.capacity ? `${ data.capacity }Ah` : null,

                data?.current ? `${ data.current }A` : null

            ].filter ( Boolean ).join ( " " );

    const metaDescription = localizedValue({
        lv: `${ productTypeLabels.lv } ${ productCore }${ productSpecs ? ` ${ productSpecs }.` : "." } Pieejams Tireshop.lv ar ātru piegādi un profesionālu servisu.`,
        en: `${ productTypeLabels.en } ${ productCore }${ productSpecs ? ` ${ productSpecs }.` : "." } Available at Tireshop.lv with fast delivery and professional service.`,
        ru: `${ productTypeLabels.ru } ${ productCore }${ productSpecs ? ` ${ productSpecs }.` : "." } Доступно в Tireshop.lv с быстрой доставкой и профессиональным сервисом.`
    }, currentLanguage);

    /** Return component */

    return ( <div className={ `content single-product single-${ data.productType }` }>

        <Helmet defer={ false }>

            <title>{ `Tireshop.lv | ${ data.manufacturer.name.toUpperCase () } ${ data.model }` }</title>

            <meta
                name="description"
                content={ metaDescription }
            />

            <meta
                name="robots"
                content={ getRobotsDirective ( currentLanguage ) }
            />

            <link rel="canonical" href={ canonicalHref } />

            { alternateLinks.map((item) => (
                <link
                    key={ item.hreflang }
                    rel="alternate"
                    hrefLang={ item.hreflang }
                    href={ item.href }
                />
            )) }

        </Helmet>

        <div className="title">
            
            <h2>

                { `${ data.manufacturer.name.toUpperCase () } - ${ data.model } - ` }

                { ( data.productType === "tire" || data.productType === "rim" ) &&

                    <span>

                        { data.productType === "tire" && <Fragment>

                            { `${ data.width } | ${ data.height } | R${ parseInt ( data.diameter ) }${ data?.isCTire ? "C" : "" } ${ data?.loadIndex ?  `| ${data?.loadIndex}` : "" }${ data?.speedRating ? data?.speedRating?.toUpperCase () : "" }` }

                        </Fragment> }

                        { data.productType === "rim" && <Fragment>

                            {/* { `${ data?.width || "-" }J | R${ parseInt ( data?.diameter ) || "-" } | ${ data?.pitchCircleDiameter || "-" } | ET${ data?.offset || "-" } | CB${ data?.centreBore || "-" } | ${ data?.color }` } */}

                            {

                                [

                                    data?.width ? `${ data?.width }J` : null,

                                    data?.diameter ? `R${ parseInt ( data?.diameter ) }` : null,

                                    data?.pitchCircleDiameter ? `${ data?.pitchCircleDiameter }` : null,

                                    data?.offset ? `ET${ data?.offset }` : null,

                                    data?.centreBore ? `CB${ data?.centreBore }` : null,

                                    data?.color ? `${ data?.color }` : null

                                ].filter ( Boolean ).join ( " | " )

                            }

                        </Fragment> }

                    </span>

                }

            </h2>

            <span className="product_id">

                ID: { data.id }

            </span>
            
        </div>
    
        <div className="layout">

            <section>{ children }</section>

        </div>
    
    </div> );

}

/** Export component */
 
export default SingleProductLayout;
